/* ════════════════════════════════════════════════════════════════════
   LuxeCanvasArt Header / Navigation behaviour
   - Mega-menu hover state machine (configurable delay)
   - Mobile drawer + 2-screen sub-navigation
   - ESC / outside-click / scroll-away closers
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lcHeaderNavInit === '1') return;
    root.dataset.lcHeaderNavInit = '1';

    var hoverDelay = parseInt(root.dataset.hoverDelay, 10);
    if (isNaN(hoverDelay)) hoverDelay = 300;
    var closeDelay = 200;

    // ─── Mega menu state ───
    var triggers = root.querySelectorAll('[data-mega-trigger]');
    var panels = root.querySelectorAll('[data-mega-panel]');
    var scrim = root.querySelector('[data-mega-scrim]');
    var openTimer = null;
    var closeTimer = null;
    var current = null;
    var startScrollY = 0;

    function openMega(name) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (current === name) return;
      panels.forEach(function (p) {
        p.dataset.open = (p.getAttribute('data-mega-panel') === name) ? 'true' : 'false';
      });
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t.getAttribute('data-mega-trigger') === name ? 'true' : 'false');
      });
      if (scrim) scrim.dataset.open = 'true';
      current = name;
      startScrollY = window.scrollY;
    }
    function closeMega() {
      panels.forEach(function (p) { p.dataset.open = 'false'; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (scrim) scrim.dataset.open = 'false';
      current = null;
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, closeDelay);
    }

    triggers.forEach(function (t) {
      var name = t.getAttribute('data-mega-trigger');
      t.addEventListener('mouseenter', function () {
        if (openTimer) clearTimeout(openTimer);
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        openTimer = setTimeout(function () { openMega(name); }, hoverDelay);
      });
      t.addEventListener('mouseleave', function () {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        scheduleClose();
      });
      t.addEventListener('focus', function () { openMega(name); });
      t.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        // Real link follows on click — let it through (UX: clicking trigger goes to collection page).
      });
    });

    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      p.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (current) closeMega();
        closeDrawer();
      }
    });

    // Close mega when scrolling > 80px from where it opened
    var scrollRaf = null;
    window.addEventListener('scroll', function () {
      if (!current) return;
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        if (Math.abs(window.scrollY - startScrollY) > 80) closeMega();
      });
    }, { passive: true });

    // Click outside any panel/trigger closes
    document.addEventListener('click', function (e) {
      if (!current) return;
      if (e.target.closest('[data-mega-panel]') || e.target.closest('[data-mega-trigger]')) return;
      closeMega();
    });

    // ─── Mobile drawer (sits outside the <header> as a sibling — use document scope) ───
    var drawer = document.querySelector('[data-lc-drawer]');
    var toggle = root.querySelector('[data-lc-drawer-toggle]');
    var lastFocus = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.dataset.open = 'true';
      document.body.classList.add('lc-nav-locked');
      var firstFocusable = drawer.querySelector('a, button');
      if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 50);
    }
    function closeDrawer() {
      if (!drawer || drawer.dataset.open !== 'true') return;
      drawer.dataset.open = 'false';
      document.body.classList.remove('lc-nav-locked');
      // Reset sub-screens
      drawer.querySelectorAll('[data-lc-drawer-sub]').forEach(function (s) { s.dataset.open = 'false'; });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (toggle) toggle.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.querySelectorAll('[data-lc-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      // Sub-screen open
      drawer.querySelectorAll('[data-lc-drawer-sub-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-lc-drawer-sub-open');
          var sub = drawer.querySelector('[data-lc-drawer-sub="' + name + '"]');
          if (sub) sub.dataset.open = 'true';
        });
      });
      // Sub-screen back
      drawer.querySelectorAll('[data-lc-drawer-sub-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.closest('[data-lc-drawer-sub]');
          if (sub) sub.dataset.open = 'false';
        });
      });
      // Focus trap (basic)
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = drawer.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
        var visible = Array.prototype.filter.call(focusables, function (el) {
          return el.offsetParent !== null;
        });
        if (!visible.length) return;
        var first = visible[0];
        var last = visible[visible.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      });
    }
  }

  function bootstrap() {
    document.querySelectorAll('[data-lc-header-nav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init on Shopify section :load (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lc-header-nav]');
    if (root) init(root);
  });
})();
